module.exports = __webpack_public_path__ + "static/media/Birds and Daisies.dfd9e5c8.jpg";